var card_default = {
  "link": "HpuT9",
  "container": "diu19",
  "cardLayout": "_7wx7h",
  "imageEnd": "NU5ij",
  "imageStart": "TBPBS",
  "imageTop": "-Kgkw",
  "right": "_5Z8eG",
  "ltr": "_6I-rM",
  "rtl": "Ow45S",
  "imageContainer": "bAAyj",
  "image": "DeC-C",
  "responsiveImage": "Ix1V7",
  "squareImage": "PpQh8",
  "rectangleImage": "PJuxg",
  "squareRatio": "z0GPv",
  "rectangleRatio": "Q3xKQ",
  "imageFill": "-V28h",
  "imageFit": "dRnru",
  "imageRibbon": "SMS9y"
};
export {
  card_default as default
};
//# sourceMappingURL=card-scss.js.map
